import { createRouter, createWebHistory } from 'vue-router'
import BodyView from "@/layout/BodyView.vue"
import indexDashbord from "@/pages/indexDashbord.vue"
import Login from "@/pages/Login.vue"
import AltaUsuarios from "@/pages/usuarios/AltaUsuarios.vue"
import ConsultaUsuarios from "@/pages/usuarios/ConsultaUsuarios.vue"
import AltaCliente from "@/pages/clientes/AltaCliente.vue"
import AltaViajero from "@/pages/clientes/AltaViajero.vue"
import ConsultarClientes from "@/pages/clientes/ConsultarClientes.vue"
import SolicitudesViajero from "@/pages/viajero/SolicitudesViajero.vue"
import DetalleCliente from "@/pages/clientes/DetalleCliente.vue"
import CrearViaje from '@/pages/trips/CrearViaje.vue'
import ConsultarViajes from '@/pages/trips/ConsultarViajes.vue'
import ViajesPublicados from '@/pages/trips/ViajesPublicados.vue'
import EditarViaje from '@/pages/trips/EditarViaje.vue'
import DetalleViaje from '@/pages/trips/DetalleViaje.vue'
import CrearPaquete from '@/pages/packages/CrearPaquete.vue'
import ConsultarPaquetes from '@/pages/packages/ConsultarPaquetes.vue'
import ObjetosProhibidos from '@/pages/configuracion/ObjetosProhibidos.vue'
import DepartamentosPaquete from '@/pages/configuracion/DepartamentosPaquete.vue'
import TarifaEnvio from '@/pages/configuracion/TarifaEnvio.vue'
import ComisionPagos from '@/pages/configuracion/ComisionPagos.vue'
import StripeConnect from '@/pages/configuracion/StripeConnect.vue'
import DashboardPagos from '@/pages/payments/DashboardPagos.vue'
import EscrowPagos from '@/pages/payments/EscrowPagos.vue'
import store from '@/store'

const routes = [
  {
    path: '/login',
    name: 'login',
    component: Login,
    meta: { title: 'Iniciar sesión - Nexyo', public: true },
  },
  {
    path: '/',
    component: BodyView,
    meta: { requiresAuth: true },
    children: [
      {
        path: '/',
        name: 'dashbord',
        component: indexDashbord,
        meta: {
          title: 'Dashboard - Nexyo',
        },
      },
      {
        path: '/usuarios/alta',
        name: 'alta-usuarios',
        component: AltaUsuarios,
        meta: { title: 'Alta usuarios - Nexyo' },
      },
      {
        path: '/usuarios/consulta',
        name: 'consulta-usuarios',
        component: ConsultaUsuarios,
        meta: { title: 'Consulta usuarios - Nexyo' },
      },
      {
        path: '/clientes/alta-cliente',
        name: 'crear-cliente',
        component: AltaCliente,
        meta: { title: 'Dar de alta cliente - Nexyo' },
      },
      {
        path: '/clientes/crear',
        redirect: (to) =>
          to.query?.role === 'CONDUCTOR_VIAJERO'
            ? '/clientes/alta-viajero'
            : '/clientes/alta-cliente',
      },
      {
        path: '/clientes/alta-viajero',
        name: 'crear-viajero',
        component: AltaViajero,
        meta: { title: 'Dar de alta viajero - Nexyo' },
      },
      {
        path: '/clientes/consulta',
        name: 'consultar-clientes',
        component: ConsultarClientes,
        meta: { title: 'Consultar clientes - Nexyo' },
      },
      {
        path: '/clientes/detalle/:id',
        name: 'detalle-cliente',
        component: DetalleCliente,
        meta: { title: 'Detalle cliente - Nexyo' },
      },
      {
        path: '/viajero/solicitudes',
        name: 'solicitudes-viajero',
        component: SolicitudesViajero,
        meta: { title: 'Solicitudes viajero - Nexyo' },
      },
      {
        path: '/trips/crear',
        name: 'crear-viaje',
        component: CrearViaje,
        meta: { title: 'Crear viaje - Nexyo' },
      },
      {
        path: '/trips/consulta',
        name: 'consultar-viajes',
        component: ConsultarViajes,
        meta: { title: 'Consultar viajes - Nexyo' },
      },
      {
        path: '/trips/publicados',
        name: 'viajes-publicados',
        component: ViajesPublicados,
        meta: { title: 'Viajes publicados - Nexyo' },
      },
      {
        path: '/trips/editar/:id',
        name: 'editar-viaje',
        component: EditarViaje,
        meta: { title: 'Editar viaje - Nexyo' },
      },
      {
        path: '/trips/detalle/:id',
        name: 'detalle-viaje',
        component: DetalleViaje,
        meta: { title: 'Detalle viaje - Nexyo' },
      },
      {
        path: '/packages/crear',
        name: 'crear-paquete',
        component: CrearPaquete,
        meta: { title: 'Crear paquete - Nexyo' },
      },
      {
        path: '/packages/consulta',
        name: 'consultar-paquetes',
        component: ConsultarPaquetes,
        meta: { title: 'Consultar paquetes - Nexyo' },
      },
      {
        path: '/configuracion/objetos-prohibidos',
        name: 'config-objetos-prohibidos',
        component: ObjetosProhibidos,
        meta: { title: 'Objetos prohibidos - Nexyo' },
      },
      {
        path: '/configuracion/departamentos-paquete',
        name: 'config-departamentos-paquete',
        component: DepartamentosPaquete,
        meta: { title: 'Departamentos de paquete - Nexyo' },
      },
      {
        path: '/configuracion/tarifa-envio',
        name: 'config-tarifa-envio',
        component: TarifaEnvio,
        meta: { title: 'Tarifa de envio - Nexyo' },
      },
      {
        path: '/configuracion/comision-pagos',
        name: 'config-comision-pagos',
        component: ComisionPagos,
        meta: { title: 'Comisión de pagos - Nexyo' },
      },
      {
        path: '/configuracion/stripe-connect',
        name: 'config-stripe-connect',
        component: StripeConnect,
        meta: { title: 'Stripe Connect - Nexyo' },
      },
      {
        path: '/payments/dashboard',
        name: 'payments-dashboard',
        component: DashboardPagos,
        meta: { title: 'Dashboard pagos - Nexyo' },
      },
      {
        path: '/payments/escrow',
        name: 'payments-escrow',
        component: EscrowPagos,
        meta: { title: 'Escrow pagos - Nexyo' },
      },
    ],
  },
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
})

/** Quita backdrops de modales y la clase offcanvas del body para evitar pantalla oscurecida sin modal visible */
function clearModalBackdropAndOverlay() {
  document.querySelectorAll('.modal-backdrop').forEach((el) => el.remove())
  document.body.classList.remove('offcanvas', 'modal-open')
  document.body.style.removeProperty('overflow')
  document.body.style.removeProperty('padding-right')
}

router.beforeEach((to, from, next) => {
  clearModalBackdropAndOverlay()
  if (typeof to.meta.title === 'string') {
    document.title = to.meta.title
  }
  const isAuthenticated = store.getters['auth/isAuthenticated']
  if (to.meta.requiresAuth && !isAuthenticated) {
    next({ name: 'login', query: { redirect: to.fullPath } })
  } else if (to.name === 'login' && isAuthenticated) {
    next(to.query.redirect || '/')
  } else {
    next()
  }
})

export default router
